import { render } from "./DefaultTable.vue?vue&type=template&id=481a5925&scoped=true"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"

import "./DefaultTable.vue?vue&type=style&index=0&id=481a5925&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481a5925"]])

export default __exports__